const ManualAddressField = (props) => {
  return (
    <div>
      <div className="lz-input-wrapper">
        <div className="lz-table lz-table-top">
          <div className="lz-table-cell lz-cell-3-4">
            <label>lil label</label>
            <div className={'lz-input'}>
              {/* {this.checkmarkAndSpinner()} */}
              <input />
              <span className="lz-input-bar" />
            </div>
          </div>

          <div className={'lz-table-cell lz-cell-1-4'}>
            <div style={{ paddingLeft: '5px' }}>
              <label>Another lil label</label>
              <div className={'lz-input'}>
                {/* {this.checkmarkAndSpinner()} */}
                <input
                  // value={field.state.street_number}
                  // placeholder={language["address-street-number-placeholder"]}
                  type="tel"
                  // onChange={this.onChangeNumber}
                  // onKeyPress={this.onEnter}
                  // ref={(input) => {
                  //   this.numberInput = input;
                  // }}
                  // onBlur={onBlurNumber.bind(this)}
                />
                <span className="lz-input-bar" />
              </div>
            </div>
          </div>

          <div>
            <div className="lz-input-wrapper">
              <div className="lz-table lz-table-middle">
                <div className="lz-table-cell lz-cell-1-2">
                  <label>Hej</label>
                  <div className={`lz-input`}>
                    {/* <div className={this.spinnerClass()}>
                    <i className="fa fa-spinner fa-spin" />
                  </div> */}

                    <div className="lz-checkmark">
                      <i className="fa fa-check" />
                    </div>

                    <input
                    // type="number"
                    // ref={(input) => (this.zipInput = input)}
                    // onChange={(e) => this.onZipChange(e)}
                    // value={this.state.zipCodeInfo?.postcode || ''}
                    // placeholder={language['zip_placeholder']}
                    />
                    <span className="lz-input-bar" />
                  </div>
                  {/* {this.getErrorStatus('postcode') && errors} */}
                </div>
                <div className="lz-table-cell lz-cell-1-2">
                  {/* <div className={'lz-areacode' + (this.state.zipCodeInfo?.postarea ? ' is-visible' : '')}>
                    <span> {this.state.zipCodeInfo?.postarea} </span>
                  </div> */}
                  ;{/* {this.state.address?.postarea} */}
                </div>
              </div>
            </div>
            {/* {this.alertInfoBox()} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualAddressField;
